import ModalComponent from "../Modal/Modal"
import React, { useEffect, useState } from "react"
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { togglePlanStatus } from "../../features/payment/paymentSlice"
import { showSnackBar } from "../Snackbar/Snackbar"
import { useIsSupervisor } from "../../hooks/user"
import { selectFeatureFlag } from "../../features/featureFlags/selectors"
import { useUiKit } from "../UiKit/UiKitContext"


const StatusContactModal = ({ planStatus, userId, fetchDashboardData, userRole, setTriggerUpdateSidebar }) => {
  const dispatch = useDispatch()
  const isSupervisor = useIsSupervisor()
  // WS 1898306. togglePlanStatus rejects with the server's message as its payload, and the check
  // below never matched that shape, so a refused change closed the modal with nothing said.
  const reportFailure = useSelector(selectFeatureFlag('PLAN_STATUS_REPORT_FAILURE'))
  const [value, setValue] = useState(planStatus)
  const { button: kitButton } = useUiKit()

  const handleChange = (event) => {
    setValue(event?.target?.value)
  }

  useEffect(() => {
    setValue(planStatus)
  }, [planStatus])
  const saveChanges = async () => {
    // Send what the operator picked. This used to send nothing and let the server invert,
    // which was invisible with two options and impossible with three — there is no way to
    // toggle *to* Canceled.
    const response = await dispatch(togglePlanStatus({ userId, status: value }))
    if (reportFailure) {
      response?.error && showSnackBar("error", typeof response.payload === 'string' ? response.payload : 'Failed to change payment plan status')
    } else {
      response?.payload?.data?.status === 400 && showSnackBar("error", "Please Generate Plan first")
    }
    fetchDashboardData()
    setTriggerUpdateSidebar(prev => !prev)
  }

  const saveChangesOrThrow = async () => {
    const response = await dispatch(togglePlanStatus({ userId, status: value }))
    if (response?.error) {
      showSnackBar("error", typeof response.payload === 'string' ? response.payload : 'Failed to change payment plan status')
      throw new Error('not changed')
    }
    fetchDashboardData()
    setTriggerUpdateSidebar(prev => !prev)
  }

  const isActiveStatus = planStatus === 'active'
  const isCanceledStatus = planStatus === 'canceled'

  // Canceled is a settled end state, not a fault, so it reads grey rather than red.
  const tone = isActiveStatus
    ? { bg: 'bg-primary-success-600', hover: 'hover:bg-primary-success-500' }
    : isCanceledStatus
      ? { bg: 'bg-gray-500', hover: 'hover:bg-gray-400' }
      : { bg: 'bg-primary-error-600', hover: 'hover:bg-primary-error-500' }

  planStatus = planStatus || 'inactive'
  return (
    <ModalComponent
      modalButtonTitle="Save"
      disabled={planStatus === value}
      disableStyleBtn={userRole !== 'customer' && !isSupervisor}
      title="Change Plan Status"
      onClose={() => setValue(planStatus)}
      buttonTitle={isActiveStatus ? 'Active' : isCanceledStatus ? 'Canceled' : 'Inactive'}
      buttonTitleStyle="justify-center"
      buttonClasses={`${tone.bg} rounded-lg h-10 text-md`}
      buttonHover={tone.hover}
      buttonWidth="w-full"
      functionButton={() => (kitButton ? saveChangesOrThrow() : saveChanges())}
      awaitFunctionButton={kitButton}
    >
      <div className="max-w-[630px] flex flex-col">
        <FormControl>
          <RadioGroup
            defaultValue="inactive"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={handleChange}
            sx={{ my: 1 }}
          >
            <FormControlLabel sx={{ gap: 1 }} value="active" control={<Radio />} label="Active" />
            <FormControlLabel sx={{ gap: 1 }} value="inactive" control={<Radio />} label="Inactive" />
            <FormControlLabel sx={{ gap: 1 }} value="canceled" control={<Radio />} label="Canceled" />
          </RadioGroup>
        </FormControl>
      </div>
    </ModalComponent>
  )
}


export default StatusContactModal
